
import * as React from 'react';
import { ReeferCommandsGrid } from '../../childcomponents/ReeferCommandsGrid';
import { PopupWindow } from '../../sharedcomponents/PopupWindow';
import { RCUtils } from '../../../RCUtils';
import $ from 'jquery';
var Config: any = require('../../../Config.json');

interface VCCheckBoxData {
    enableVCCheckBox: boolean;
    disableVCCheckBoxOption: boolean;
    disableVCDropDown: boolean;
    disableVCOption: boolean;
    selectedVCData: server.VesselInformation;
    dropDownVCData: server.VesselInformation[];
    isVCMessage: boolean;
}
const emptyVCCheckBoxData: VCCheckBoxData = { enableVCCheckBox: false, disableVCCheckBoxOption: false, disableVCDropDown: false, disableVCOption: false, selectedVCData: null, dropDownVCData: [], isVCMessage: false };

export interface GuestReeferConfigurationState {
    SelectedReefers: any[];
    SelectedConfigurationCmd: string;
    RowData: server.USP_UnitCurrentConditionUI_Model[];
    Filters: server.ForwardCommandParameters;
    GuestReeferCmds: server.GuestReeferConfigurationOptions[];
    GuestReeferCmdValue: string;
    GuestReeferCmdSelectedValue: number;
    GuestReeferCmdDetails: server.GuestReeferConfigurationCmdDetails;
    VCCheckBoxInfo: VCCheckBoxData;  
    IsCommandIssued: boolean;
    PrevSelectedItems: any[];
}

export class GuestReeferConfiguration extends React.Component<any, GuestReeferConfigurationState> {
    constructor(props: any) {
        super(props);
        $('#globalLoader').show();
        var filterSet = this.setDefaultFilters();
        this.state = { SelectedReefers: [], SelectedConfigurationCmd: "0", RowData: [], Filters: filterSet, GuestReeferCmds: [], GuestReeferCmdValue: "", GuestReeferCmdSelectedValue: -1, GuestReeferCmdDetails: null, VCCheckBoxInfo: emptyVCCheckBoxData, IsCommandIssued: false, PrevSelectedItems: [] };
       
    }

    componentDidMount() {
        if (this.props.reeferData != null && this.props.reeferData.length > 0) {
            this.setState({ RowData: this.props.reeferData });
            this.renderGuestReeferCmdGrid(this.props.reeferData);
            this.loadGuestReeferCmdData();
        }
        if (this.props.VCCheckBoxInfo != undefined && this.props.VCCheckBoxInfo != null) {
            this.setState({ VCCheckBoxInfo: this.props.VCCheckBoxInfo });
        }
        $('#globalLoader').hide();
    }
    loadGuestReeferCmdData() {
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetGuestReeferCmds')
        RCUtils.fetchFaultRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<server.GuestReeferConfigurationOptions[]>)
            .then(data => {
                this.setState({ GuestReeferCmds: data }, () => { this.GetGuestReeferConfigurationValue(this.state.GuestReeferCmds[0].GuestReeferCmdValue); });
                $('#globalLoader').hide();
            });
    }
    public ConfigurationCmdChange(event: any): void {
        this.setState({ GuestReeferCmdValue: '' });
        //this.setState({ [event.currentTarget.name]: event.currentTarget.value });
        var result: any = false;
        if (event.currentTarget.value != 'undefined' && event.currentTarget.value != null && event.currentTarget.value != '-1') {      
            result = this.GetGuestReeferConfigurationValue(event.currentTarget.value);
        }
        if (result) {
            var reefersData = this.props.reeferData;
            if (reefersData != undefined && reefersData != null && reefersData.length > 0) {
                $('#globalLoader').show();
                this.renderGuestReeferCmdGrid(reefersData);
            }
        } 
    }
   GetGuestReeferConfigurationValue(value: any) {
       $('#globalLoader').show();
       var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GuestReeferCmdDetails?GuestReeferConfigurationValue=' + value, { method: 'POST', headers: { 'Accept': 'applicatio/json', 'Content-Type': 'application/json' } })
       //var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GuestReeferCmdDetails', { method: 'POST', body: value, headers: { 'Accept': 'applicatio/json', 'Content-Type': 'application/json' } })
       var configurationValue = "";
       RCUtils.fetchFaultRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<server.GuestReeferConfigurationCmdDetails>)
            .then(data => {
                this.setState({ GuestReeferCmdDetails: data }, () => {
                    var configurationValue = this.state.GuestReeferCmdDetails.ConfigurationValue + "   " + this.state.GuestReeferCmdDetails.ConfigurationValueDesc;  
                    this.setState({ GuestReeferCmdValue: JSON.parse(JSON.stringify(configurationValue)) });
                });
                $('#globalLoader').hide();
                return true;
            });
    }
    submitGuestReeferCmd() {
        if (this.state.GuestReeferCmdDetails != null) {
            var command = this.state.GuestReeferCmdDetails.CommandName;
            var paramValue = this.state.GuestReeferCmdDetails.ConfigurationValue;
            if (paramValue != "" && paramValue != null) {
                var refreshGrid = this.props.refreshGrid;
                ReeferCommandsGrid.submitTemperatureCommands(command, paramValue, refreshGrid);
                this.setState({ IsCommandIssued: true, PrevSelectedItems: this.props.reeferData }, () => { this.props.IsCommandIssued(this.state.IsCommandIssued); this.props.PrevSelectedItems(this.props.reeferData) });
            }
            else
                PopupWindow.showErrorMessage("Alert", "Please select Guest Reefer Configuration Command.");
        }
    }

    componentWillReceiveProps(nextprops: any) {
        var reeferData = nextprops.reeferData;
        if (reeferData != undefined && reeferData != null && reeferData.length > 0) {
            $('#globalLoader').show();
            this.renderGuestReeferCmdGrid(reeferData);
            this.loadGuestReeferCmdData();
        }
        if (nextprops.VCCheckBoxInfo != undefined && nextprops.VCCheckBoxInfo != null) {
            this.setState({ VCCheckBoxInfo: nextprops.VCCheckBoxInfo });
        }
    }

    renderGuestReeferCmdGrid(reeferData: any) {
        var cmdName = "";
        if (this.state.GuestReeferCmdDetails != undefined && this.state.GuestReeferCmdDetails != null) {
            cmdName = this.state.GuestReeferCmdDetails.CommandName;
        }
        this.setState({ SelectedReefers: reeferData, SelectedConfigurationCmd: "0" });
        this.state.Filters.CommandName = cmdName;
        this.state.Filters.SelectedReefers = reeferData;
        var forwardCommandParams = JSON.stringify(this.state.Filters);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetForwardCommandData', { method: 'POST', body: forwardCommandParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.USP_UnitCurrentConditionUI_Model[]>)
            .then(data => {
                this.setState({ RowData: data });
                $('#globalLoader').hide();
            });
    }

    setDefaultFilters() {
        var filters: server.ForwardCommandParameters = {
            SelectedReefers: [], CommandName: "", TempValue: "", OtherValue: null, IsCmdSendViaVC: null, VesselInfo: null
        };
        return filters;
    }

    UpdateVCCheckBoxInfo(VCInfo: any) {
        if (this.props.UpdateVCCheckBoxInfo != null && this.props.UpdateVCCheckBoxInfo != 'undefined')
            this.props.UpdateVCCheckBoxInfo(VCInfo);
    } 

    public render() {
            var configCmds = this.state.GuestReeferCmds;
        var configCmdsOptions = configCmds.map(function (cmd) {
            return (
                <option key={cmd.GuestReeferCmdKey} value={cmd.GuestReeferCmdValue}>{cmd.GuestReeferCmdValue}</option>
            );
        });
        return <div>
            <div className="modal-controls-container">
                <div className='row'>
                    <div className='col-lg-3'>
                        <span className='float-end col-form-label'> Guest Reefer Configuration Command :</span>
                    </div>
                    <div className='col-lg-4'> <select className='form-control' name="SelectedConfigurationCmd" onChange={e => this.ConfigurationCmdChange(e)} value={this.state.SelectedConfigurationCmd}> 
                                 {configCmdsOptions}
                            </select>
                    </div>                   
                </div>
                <div className='input-group row'>
                    <div className='col-lg-3'>
                       <span className='float-end col-form-label'> Guest Reefer Configuration Value :</span>
                    </div>
                    <div className='col-lg-4'>
                        <span className='float-end col-form-label'>  {this.state.GuestReeferCmdValue}</span>
                    </div>
                </div>
            </div>
            <ReeferCommandsGrid reeferFormatter={this.props.reeferFormatter} selectedReefers={this.state.RowData} ChangeO2andCo2Action={true} commandName={this.state.Filters.CommandName} VCCheckBoxInfo={this.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={this.UpdateVCCheckBoxInfo.bind(this)}></ReeferCommandsGrid>
            <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                <button type="button" className="btn btn-primary" onClick={this.submitGuestReeferCmd.bind(this)}>Save</button>
            </div>
        </div>
    }
}